"use strict";var e=require("styled-components").css`
    position: relative;
    margin: 0;

    .inner {
        max-width: ${({theme:e})=>e.widths.small};
        margin: 0 auto;
        padding: 0;
        display: grid;
        grid-row-gap: 15px;
        grid-template-columns: minmax(0, 1fr);

        @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
            max-width: ${({theme:e})=>e.widths.xlarge};
            grid-template-columns: minmax(0, 1fr) 396px;
            grid-column-gap: 47px;
            grid-row-gap: 0;
            padding: 0;
        }
    }

    @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        .intro.modal-open .inner {
            grid-template-columns: unset;
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
